<script setup lang="ts">
import Button from 'primevue/button';
import { Section, SplitBar, Toolbar, Typography } from '@apparatix/library/core';
import { button as greenButtonTheme } from '@apparatix/theme/Green';

type Props = {
  isEditing?: boolean;
  isLoading?: boolean;
  disableEdit?: boolean;
  disableSave?: boolean;
  header?: string;
  hideButton?: boolean;
  enableDelete?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  header: 'Details',
});

const emit = defineEmits<{
  (e: 'on:edit-click'): void;
  (e: 'on:save-click'): void;
  (e: 'on:cancel-click'): void;
  (e: 'on:delete-click'): void;
}>();
</script>
<template>
  <Section :footer="props.isEditing">
    <template #title>
      <SplitBar class="pb-3">
        <template #left>
          <Typography variant="section-heading">
            {{ props.header }}
          </Typography>
        </template>
        <template #right>
          <Toolbar align="right">
            <Button
              v-if="!props.hideButton && props.enableDelete"
              icon="pi pi-trash"
              label="Delete"
              severity="danger"
              variant="outlined"
              :disabled="props.isEditing || props.isLoading || props.disableEdit"
              @click="emit('on:delete-click')"
            />
            <Button
              v-if="!props.hideButton"
              icon="pi pi-pen-to-square"
              :label="props.isEditing ? 'Editing' : 'Edit'"
              variant="outlined"
              :disabled="props.isEditing || props.isLoading || props.disableEdit"
              @click="emit('on:edit-click')"
            />
          </Toolbar>
        </template>
      </SplitBar>
    </template>
    <slot />
    <template v-if="props.isEditing" #footer>
      <Toolbar align="right">
        <Button
          label="Cancel"
          severity="secondary"
          :disabled="props.isLoading"
          @click="emit('on:cancel-click')"
        />
        <Button
          :label="props.isLoading ? 'Saving' : 'Save'"
          :icon="props.isLoading ? 'pi pi-spin pi-spinner' : undefined"
          :dt="greenButtonTheme"
          :disabled="props.disableSave || props.isLoading"
          @click="emit('on:save-click')"
        />
      </Toolbar>
    </template>
  </Section>
</template>
